import {Navigate, useParams} from 'react-router-dom';
import {NavBar} from '@/components/NavBar';
import {Failure, Inprogress, Success} from '@/components/Payments';
import {PaymentProcess} from '@/enums';
import {PaymentProcessParams} from '@/interface';
import {paths} from '@/router';
import {HorizontalFullContainer, ScrollBody} from '@/styled-components';

const PayProcess = () => {
  const {status, ...rest} = useParams<PaymentProcessParams | any>();

  if (!status || !Object.values(PaymentProcess).includes(status as any)) {
    return <Navigate to={paths.intro} />;
  }

  return (
    <HorizontalFullContainer>
      <NavBar disabled={status === PaymentProcess.inprogress} />
      <ScrollBody>
        {status === PaymentProcess.inprogress && <Inprogress {...rest} />}
        {status === PaymentProcess.fail && <Failure {...rest} />}
        {status === PaymentProcess.success && <Success {...rest} />}
      </ScrollBody>
    </HorizontalFullContainer>
  );
};

export default PayProcess;
